const CHANNEL_NAME = 'pulsora-user-tab-presence';
const tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
let activeUserId = null;
let channel = null;
const probes = new Map();

try {
  if ('BroadcastChannel' in window) channel = new BroadcastChannel(CHANNEL_NAME);
} catch (_) {
  channel = null;
}

if (channel) {
  channel.onmessage = event => {
    const message = event.data || {};
    if (!message.type || message.from === tabId) return;

    if (message.type === 'probe' && activeUserId && String(message.userId) === String(activeUserId)) {
      channel.postMessage({
        type: 'occupied',
        userId: String(activeUserId),
        from: tabId,
        to: message.from,
      });
      return;
    }

    if (message.type === 'occupied' && message.to === tabId) {
      const resolve = probes.get(String(message.userId));
      if (resolve) resolve(true);
    }
  };
}

/**
 * Evita que una pestaña duplicada conserve el mismo usuario que otra pestaña
 * del mismo navegador. Distintos usuarios no interfieren entre sí.
 */
export const claimUserForTab = userId => {
  const normalized = String(userId || '');
  if (!normalized) return Promise.resolve(true);
  if (!channel) {
    activeUserId = normalized;
    return Promise.resolve(true);
  }

  return new Promise(resolve => {
    let settled = false;
    const finish = occupied => {
      if (settled) return;
      settled = true;
      probes.delete(normalized);
      if (!occupied) activeUserId = normalized;
      resolve(!occupied);
    };
    probes.set(normalized, occupied => finish(Boolean(occupied)));
    channel.postMessage({ type: 'probe', userId: normalized, from: tabId });
    window.setTimeout(() => finish(false), 180);
  });
};

export const releaseUserForTab = () => {
  activeUserId = null;
};
